import React from 'react';
interface Tab {
  id: string;
  label: string;
  icon?: React.ReactNode;
  badge?: number;
}
interface TabNavigationProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}
export const TabNavigation = ({
  tabs,
  activeTab,
  onTabChange
}: TabNavigationProps) => {
  return <div className="border-b border-gray-200 mb-6" data-id="element-85">
      <nav className="-mb-px flex space-x-6 overflow-x-auto" data-id="element-86">
        {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} className={`flex items-center gap-2 py-3 px-2 border-b-2 font-medium text-sm whitespace-nowrap transition-colors ${activeTab === tab.id ? 'border-[#F58220] text-[#0F2A52]' : 'border-transparent text-gray-500 hover:text-[#0F2A52]/80 hover:border-gray-300'}`} data-id="element-87">
            {tab.icon}
            <span data-id="element-88">{tab.label}</span>
            {tab.badge && <span className="bg-[#F58220] text-white text-xs font-medium rounded-full h-5 w-5 flex items-center justify-center" data-id="element-89">
                {tab.badge}
              </span>}
          </button>)}
      </nav>
    </div>;
};